<template>
  <section class="col-start-2 col-end-12 row-start-3 row-end-4">
    <div
      id="steps-container"
      class="container mx-auto xxl:px-6 pb-16 md:pt-16 grid md:grid-cols-2 lg:grid-cols-4 justify-center"
    >
      <div
        class="steps flex flex-col text-center my-4"
        @mouseenter="mouseOnStepper"
        @mouseleave="mouseLeaveStepper"
      >
        <div class="step-container w-full h-full">
          <div class="step bg-red-200 relative mx-auto mb-4 w-16 h-16 rounded-md transform rotate-45">
            <span
              class="step-icon absolute transform -rotate-45"
              style="top: 30%;  left: 30%;"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#F795A5"
              >
                <path
                  d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7V5Z"
                  stroke="#F795A5"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4 13C4 12.4477 4.44772 12 5 12H11C11.5523 12 12 12.4477 12 13V19C12 19.5523 11.5523 20 11 20H5C4.44772 20 4 19.5523 4 19V13Z"
                  stroke="#F795A5"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16 13C16 12.4477 16.4477 12 17 12H19C19.5523 12 20 12.4477 20 13V19C20 19.5523 19.5523 20 19 20H17C16.4477 20 16 19.5523 16 19V13Z"
                  stroke="#F795A5"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

            </span>
          </div>
          <span class="step-title mt-4 text-base leading-normal tracking-normal font-medium text-primary-black">Modernne koduleht</span>
          <p class="step-description max-w-xs mx-auto tracking-wider leading-relaxed mt-2 text-sm font-light text-primary-black">Tõsta oma firma käivet silmapaistva kodulehega.</p>
        </div>
      </div>
      <div
        class="steps flex flex-col text-center my-4"
        @mouseenter="mouseOnStepper"
        @mouseleave="mouseLeaveStepper"
      >
        <div class="step-container w-full h-full">
          <div class="step relative bg-green-200 mx-auto mb-4 w-16 h-16 rounded-md transform rotate-45">
            <span
              class="step-icon absolute transform -rotate-45"
              style="top: 30%;  left: 30%;"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#9ae6b4"
              >
                <path
                  d="M5 3V7M3 5H7M6 17V21M4 19H8M13 3L15.2857 9.85714L21 12L15.2857 14.1429L13 21L10.7143 14.1429L5 12L10.7143 9.85714L13 3Z"
                  stroke="#9ae6b4"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>
          <span class="step-title mt-4 text-base leading-normal tracking-normal font-medium text-primary-black">Disainiline perfektsus</span>
          <p class="step-description max-w-xs mx-auto tracking-wider leading-relaxed mt-2 text-sm font-light text-primary-black">Uudsed disainid ja efektsed visuaalsed lahendused.</p>
        </div>
      </div>
      <div
        class="steps flex flex-col text-center my-4"
        @mouseenter="mouseOnStepper"
        @mouseleave="mouseLeaveStepper"
      >
        <div class="step-container w-full h-full">
          <div class="step relative bg-indigo-300 mx-auto mb-4 w-16 h-16 rounded-md transform rotate-45">
            <span
              class="step-icon absolute transform -rotate-45"
              style="top: 30%;  left: 30%;"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#667EEA"
              >
                <path
                  d="M11 4C11 2.89543 11.8954 2 13 2C14.1046 2 15 2.89543 15 4V5C15 5.55228 15.4477 6 16 6H19C19.5523 6 20 6.44772 20 7V10C20 10.5523 19.5523 11 19 11H18C16.8954 11 16 11.8954 16 13C16 14.1046 16.8954 15 18 15H19C19.5523 15 20 15.4477 20 16V19C20 19.5523 19.5523 20 19 20H16C15.4477 20 15 19.5523 15 19V18C15 16.8954 14.1046 16 13 16C11.8954 16 11 16.8954 11 18V19C11 19.5523 10.5523 20 10 20H7C6.44772 20 6 19.5523 6 19V16C6 15.4477 5.55228 15 5 15H4C2.89543 15 2 14.1046 2 13C2 11.8954 2.89543 11 4 11H5C5.55228 11 6 10.5523 6 10V7C6 6.44772 6.44772 6 7 6H10C10.5523 6 11 5.55228 11 5V4Z"
                  stroke="#667EEA"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

            </span>
          </div>
          <span class="step-title mt-4 text-base leading-normal tracking-normal font-medium text-primary-black">Mitmekülgsed erilahendused</span>
          <p class="step-description max-w-xs mx-auto tracking-wider leading-relaxed mt-2 text-sm font-light text-primary-black">Spetsiaalsed lahendused just Teie ettevõttele.</p>
        </div>
      </div>
      <div
        class="steps flex flex-col text-center my-4"
        @mouseenter="mouseOnStepper"
        @mouseleave="mouseLeaveStepper"
      >
        <div class="step-container w-full h-full">
          <div class="step relative bg-blue-300 mx-auto mb-4 w-16 h-16 rounded-md transform rotate-45">
            <span
              class="step-icon absolute transform -rotate-45"
              style="top: 30%;  left: 30%;"
            >
              <svg
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#63b3ed"
              >
                <path
                  d="M12 18H12.01M8 21H16C17.1046 21 18 20.1046 18 19V5C18 3.89543 17.1046 3 16 3H8C6.89543 3 6 3.89543 6 5V19C6 20.1046 6.89543 21 8 21Z"
                  stroke="#63b3ed"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

            </span>
          </div>
          <span class="step-title mt-4 text-base leading-normal tracking-normal font-medium text-primary-black">Mobiilset kättesaadav</span>
          <p class="step-description max-w-xs mx-auto tracking-wider mt-2 text-sm font-light text-primary-black">Loome veebilehti, mis täidavad oma eesmärki ka mobiilikasutajale.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
  name: "Stepper",
  computed: {
    isMobile: function () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
  },
  methods: {
    iconElements(e) {
      const stepContainer = e.querySelector(".step-container");
      const step = stepContainer.querySelector(".step");
      const icon = stepContainer.querySelector(".step-icon");
      const title = stepContainer.querySelector(".step-title");
      const description = stepContainer.querySelector(".step-description");
      return { step, icon, title, description };
    },
    handleIconInteraction(e, rotate, scale, opacity) {
      const { step, icon, title, description } = this.iconElements(e);
      gsap.to(step, {
        rotate: rotate,
        ease: "slow",
        scale: scale,
        opacity: opacity,
        duration: 1,
      });
      gsap.to(icon, {
        rotate: -rotate,
        ease: "slow",
        scale: scale,
        opacity: opacity,
        duration: 1,
      });
      gsap.to(title, {
        ease: "slow",
        scale: scale,
        opacity: opacity,
        duration: 1,
      });
      gsap.to(description, {
        ease: "slow",
        scale: scale,
        opacity: opacity,
        duration: 1,
      });
    },
    mouseOnStepper(e) {
      if (!this.isMobile) {
        const element = e.target;
        this.handleIconInteraction(element, 135, 1.1, 1);
      }
    },
    mouseLeaveStepper(e) {
      if (!this.isMobile) {
        const element = e.target;
        this.handleIconInteraction(element, 45, 1, 0.8);
      }
    },
    inViewPortAnimations() {
      const scroller = this.$parent.$refs["scrollSections"];
      // const trigger = "#steps-container";
      const _self = this;
      ScrollTrigger.matchMedia({
        "(max-width: 767px)": function () {
          const elements = gsap.utils.toArray(".steps");
          elements.forEach((step) => {
            gsap.to(step.querySelector(".step-container"), {
              duration: 1,
              y: 0,
              opacity: 0.8,
              scale: 1,
              ease: "slow",
              autoAlpha: 1,
              scrollTrigger: {
                trigger: step,
                scroller: scroller,
              },
            });
          });
        },
        "(min-width: 768px) and (max-width: 1023px)": function () {
          const elements = gsap.utils.toArray(".steps");
          elements.forEach((step) => {
            gsap.to(step.querySelector(".step-container"), {
              duration: 1,
              y: 0,
              opacity: 0.8,
              scale: 1,
              ease: "slow",
              autoAlpha: 1,
              scrollTrigger: {
                trigger: step,
                scroller: scroller,
              },
            });
          });
        },
        "(min-width: 1024px)": function () {
          const trigger = "#steps-container";
          const scrollTriggerDefaults = {
            trigger: trigger,
            scroller: scroller,
            start: "top 100%",
            end: "bottom 35%",
          };
          gsap.to(".step-container", {
            duration: 1,
            y: 0,
            opacity: 0.8,
            scale: 1,
            ease: "slow",
            autoAlpha: 1,
            stagger: {
              grid: [1, 4],
              from: 0,
              amount: 0.3,
            },
            scrollTrigger: {
              ...scrollTriggerDefaults,
            },
          });
        },
        all: function () {
          if (_self.isMobile) {
            const elements = gsap.utils.toArray(".steps");
            elements.forEach((step) => {
              ScrollTrigger.create({
                trigger: step,
                scroller: scroller,
                start: "center center",
                onToggle: (self) => {
                  if (self.isActive)
                    _self.handleIconInteraction(self.trigger, 135, 1.1, 1);
                  else _self.handleIconInteraction(self.trigger, 45, 1, 0.8);
                },
              });
            });
          }
        },
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      gsap.set(".step-container", {
        y: 100,
        opacity: 0.5,
        scale: 0.8,
        autoAlpha: 0,
      });
      this.inViewPortAnimations();
    });
  },
};
</script>

<style scoped>
.step-container {
  /*will-change: opacity, visibility, transform;*/
}
</style>
